import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts'

type EChartsOption = echarts.EChartsOption

export type ScoreMapping = Record<string, number>

export interface ChartData {
	skill: string
	scoreMapping: ScoreMapping
}

export interface ChartSkill {
	id: string
	name: string
	color: string
}

export interface ChartProps {
	data: ChartData[]
	skills: ChartSkill[]
}

const Pyechats1 = ({ data, skills }: ChartProps) => {
	const chartRef = useRef<HTMLDivElement>(null)

	// useEffect(() => {
	// 	console.log('Skills Array:', skills) // Log the skills array
	// 	if (chartRef.current) {
	// 		const myChart = echarts.init(chartRef.current)

	// 		// Find the skill with name "Talent" (or change this to the skill you're looking for)
	// 		const talentSkill = skills.find(skill => skill.name === 'Talent')

	// 		console.log('Talent Skill:', talentSkill) // Log the found skill

	// 		if (talentSkill) {
	// 			const totalScore = data.reduce(
	// 				(acc, item) => acc + (item.scoreMapping[talentSkill.id] || 0),
	// 				0
	// 			)

	// 			const averageScore = totalScore / data.length
	// 			const displayScore = parseFloat(averageScore.toFixed(2))

	// 			if (displayScore > 0) {
	// 				const pieData = [
	// 					{
	// 						value: displayScore,
	// 						name: `${displayScore}`,
	// 						itemStyle: { color: talentSkill.color }
	// 					}
	// 				]

	// 				const option: EChartsOption = {
	// 					tooltip: {
	// 						trigger: 'item',
	// 						formatter: '{b}: {c} ({d}%)'
	// 					},
	// 					series: [
	// 						{
	// 							name: 'Skills',
	// 							type: 'pie',
	// 							radius: '50%',
	// 							data: pieData,
	// 							emphasis: {
	// 								itemStyle: {
	// 									shadowBlur: 10,
	// 									shadowOffsetX: 0,
	// 									shadowColor: 'rgba(0, 0, 0, 0.5)'
	// 								}
	// 							}
	// 						}
	// 					]
	// 				}

	// 				myChart.setOption(option)
	// 			} else {
	// 				console.warn('No data for Talent skill')
	// 			}

	// 			const handleResize = () => {
	// 				myChart.resize()
	// 			}

	// 			window.addEventListener('resize', handleResize)

	// 			return () => {
	// 				window.removeEventListener('resize', handleResize)
	// 				myChart.dispose()
	// 			}
	// 		} else {
	// 			console.warn('Talent skill not found in the skills list.')
	// 		}
	// 	}
	// }, [data, skills])
	useEffect(() => {
		// console.log('Skills Array:', skills)
		if (chartRef.current) {
			const myChart = echarts.init(chartRef.current)

			const talentSkill = skills.find(skill => skill.name === 'Talent')

			// console.log('Talent Skill:', talentSkill)

			if (talentSkill) {
				const maxScore = 100
				const totalScore = data.reduce(
					(acc, item) => acc + (item.scoreMapping[talentSkill.id] || 0),
					0
				)

				const scorePercentage = (totalScore / maxScore) * 100

				const pieData = [
					{
						value: scorePercentage,
						name: `Score ${Math.floor(scorePercentage)}`,
						itemStyle: { color: talentSkill.color }
					},
					{
						value: 100 - scorePercentage,
						itemStyle: { color: '#f0f0f0' },
						label: { show: false }
					}
				]

				const option: EChartsOption = {
					tooltip: {
						trigger: 'item',
						show: true
					},
					series: [
						{
							name: 'Skills',
							type: 'pie',
							radius: '50%',
							data: pieData,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						}
					]
				}

				myChart.setOption(option)

				const handleResize = () => {
					myChart.resize()
				}

				window.addEventListener('resize', handleResize)

				return () => {
					window.removeEventListener('resize', handleResize)
					myChart.dispose()
				}
			} else {
				console.warn('Talent skill not found in the skills list.')
			}
		}
	}, [data, skills])

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			<h2>Custom Assessment</h2>

			<div ref={chartRef} style={{ width: 450, height: 450 }}></div>
		</div>
	)
}

export default Pyechats1
